<template>
  <fa-icon icon="history" />
</template>
